import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export type SettingsLayout = "A" | "B";
export type ConfigMapTab =
  "general" | "groupBlocks" | "categorizations" | "normalizations";

interface ConfigMapEditorState {
  activeTab: ConfigMapTab;
  editingGroupBlockId: string | null;
  editingEntityId: string | null;
  settingsLayout: SettingsLayout;
}

const initialState: ConfigMapEditorState = {
  activeTab: "general",
  editingGroupBlockId: null,
  editingEntityId: null,
  settingsLayout:
    (localStorage.getItem("settingsLayout") as SettingsLayout) || "A",
};

const configMapEditorNewSlice = createSlice({
  name: "configMapEditorNew",
  initialState,
  reducers: {
    setActiveTab(state, action: PayloadAction<ConfigMapTab>) {
      state.activeTab = action.payload;
    },
    setEditingGroupBlockId(state, action: PayloadAction<string | null>) {
      state.editingGroupBlockId = action.payload;
    },
    setEditingEntityId(state, action: PayloadAction<string | null>) {
      state.editingEntityId = action.payload;
    },
    setSettingsLayout(state, action: PayloadAction<SettingsLayout>) {
      state.settingsLayout = action.payload;
      localStorage.setItem("settingsLayout", action.payload);
    },
    resetEditorState(state) {
      state.activeTab = "general";
      state.editingGroupBlockId = null;
      state.editingEntityId = null;
    },
  },
});

export const {
  setActiveTab,
  setEditingGroupBlockId,
  setEditingEntityId,
  setSettingsLayout,
  resetEditorState,
} = configMapEditorNewSlice.actions;

// Selectors
export const selectActiveTab = (state: RootState) =>
  state.configMapEditorNewReducer.activeTab;
export const selectEditingGroupBlockId = (state: RootState) =>
  state.configMapEditorNewReducer.editingGroupBlockId;
export const selectEditingEntityId = (state: RootState) =>
  state.configMapEditorNewReducer.editingEntityId;
export const selectSettingsLayout = (state: RootState) =>
  state.configMapEditorNewReducer.settingsLayout;

export default configMapEditorNewSlice.reducer;
